import { useInfiniteQuery, useMutation } from '@tanstack/react-query';

import { getGifts, purchaseGifts } from '../functions/giftShow';
import { GiftListParams } from '../models/giftShowModels';

export const useGetUserPurchasedGifts = (params: GiftListParams) =>
  useInfiniteQuery({
    queryKey: ['get-user-purchased-gifts', params.n],
    queryFn: getGifts,
    initialPageParam: params.n,
    getNextPageParam: (lastPage) => {
      if (lastPage.last) return lastPage.last;
      else return null;
    }
  });

export const usePurchaseGifts = () => {
  return useMutation({
    mutationKey: ['purchase-gifts'],
    mutationFn: purchaseGifts
  });
};
